module.exports = __webpack_public_path__ + "static/media/enterprise-college.beba8b79.jpg";